import React from 'react';
import { JsonEditor as JsonEditReact, githubLightTheme } from 'json-edit-react';

import './JsonEditor.css';

const JsonEditor = ({ defaultValue, onChange, ...otherProps }) => {

    const setJsonData = (data, _a, _b, _c) => {
        onChange && onChange(data);
    }

    return (
        <div className="JsonEditor">
            <JsonEditReact
                data={ defaultValue }
                setData={ setJsonData }
                theme={ githubLightTheme }
                rootName=""
                showArrayIndices={ false }
                showCollectionCount={ false }
                { ...otherProps }
            />
        </div>
    );
}

export default JsonEditor;

